/**
 * * Configuração dos componentes de radio button.
 */
export class RadioConfig {

    constructor(
      /**
       * * Texto do Radio Button.
       */
      public label: string,
      /**
       * * Valor do Radio Button.
       */
      public value?: string,
      /**
       * * Identificador do componente de input.
       */
      public id?: string,
      /**
       * * Botão Selecionado.
       */
      public selected?: boolean,
      /**
       * * Botão Desabilitado.
       */
      public disabled?: boolean
    ) {}
}
